import { inject, observer } from 'mobx-react';
import * as React from 'react';
import * as classNames from 'classnames';
import * as moment from 'moment';
import { Activity, ActivityCreateOrEdit } from 'components/activity';
import { IActivityShort } from 'common/interfaces/activity';
import { IAppOnlyStore } from 'stores/AllStores';
import { app, browserHistory } from './../../App';

// Styles
const s = require('./Activities.css');

// Props
interface IActivitiesGroupProps extends IAppOnlyStore {
    className?: string;
    activities: IActivityShort[];
    allFinished: boolean;
    title: string | null;
    isOnLeadPage?: boolean;
}

// Component
@inject('store')
@observer
export class ActivitiesGroup extends React.Component<
    IActivitiesGroupProps,
    {}
> {
    static get defaultProps(): IActivitiesGroupProps {
        return {
            className: null,
            activities: [],
            allFinished: false,
            title: null,
            isOnLeadPage: false,
        };
    }

    constructor(props: IActivitiesGroupProps) {
        super(props);
    }

    private now = moment();

    public render() {
        const { activities, title, isOnLeadPage, allFinished } = this.props;

        return (
            <div
                className={classNames(s.activityGroup, this.props.className, {
                    [s.activityGroupWide]: isOnLeadPage,
                    [s.activitiesAllFinished]: allFinished,
                })}
            >
                <div className={s.groupTitle}>{title}</div>
                <div className={s.groupList}>
                    {activities.map(activity => {
                        return this.props.store.activitiesCreateOrEdit.editingActivitiesIds.indexOf(
                            activity.id
                        ) === -1 ? (
                            <Activity
                                key={`view-${activity.id}`}
                                activity={activity}
                                onClick={this.handleActivityClick}
                                onEdit={this.handleActivityEdit}
                                onMarkAsComplete={
                                    this.handleActivityMarkAsComplete
                                }
                                loggedInUserId={this.props.store.user.id}
                                loggedInUserType={
                                    this.props.store.user.userType
                                }
                                isOnLeadPage={isOnLeadPage}
                                now={this.now}
                            />
                        ) : (
                            <ActivityCreateOrEdit
                                key={`edit-${activity.id}`}
                                activityId={activity.id}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }

    private handleActivityClick = (activityId: number) => {
        let activityIndex = -1;
        this.props.activities.some((activity, i) => {
            if (activity.id === activityId) {
                activityIndex = i;
                return true;
            }
        });

        if (activityIndex !== -1) {
            const activity = this.props.activities[activityIndex];
            this.props.store.sidebar.closeSidebar();
            browserHistory.push('/sales/lead/' + activity.provider.databaseId);
        }
    };

    private handleActivityEdit = (activityId: number) => {
        this.props.store.activitiesCreateOrEdit.startEditingExistingActivity(
            activityId
        );
    };

    private handleActivityMarkAsComplete = async (activityId: number) => {
        const { activities, leadActivities } = this.props.store;

        try {
            const userActivityIndex = activities.userActivitiesIds.indexOf(
                activityId
            );
            const leadActivityIndex = leadActivities.openLeadActivitiesIds.indexOf(
                activityId
            );
            let finished: boolean = false;

            if (userActivityIndex !== -1) {
                finished =
                    activities.userActivities[activities.userActivitiesIndex]
                        .activities[userActivityIndex].finished;
                activities.userActivities[
                    activities.userActivitiesIndex
                ].activities[userActivityIndex].savingComplete = true;
            }

            if (leadActivityIndex !== -1) {
                finished =
                    leadActivities.leadActivities[
                        leadActivities.openLeadActivitiesIndex
                    ].activities[leadActivityIndex].finished;
                leadActivities.leadActivities[
                    leadActivities.openLeadActivitiesIndex
                ].activities[leadActivityIndex].savingComplete = true;
            }

            const service = await app.service('activity');
            const patch = await service.patch(activityId, {
                finished: !finished,
            });

            if (userActivityIndex !== -1) {
                activities.userActivities[
                    activities.userActivitiesIndex
                ].activities[userActivityIndex].savingComplete = false;
                activities.userActivities[
                    activities.userActivitiesIndex
                ].activities[userActivityIndex].finished = !finished;
            }

            if (leadActivityIndex !== -1) {
                leadActivities.leadActivities[
                    leadActivities.openLeadActivitiesIndex
                ].activities[leadActivityIndex].savingComplete = false;
                leadActivities.leadActivities[
                    leadActivities.openLeadActivitiesIndex
                ].activities[leadActivityIndex].finished = !finished;
            }
        } catch (err) {
            console.error(err);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/activity/ActivitiesGroup.tsx